export type PipaConsentValue = "true" | "false" | "";

export interface IPipaConsent {
    consentDataCollection: PipaConsentValue;
    consentDataThirdparty: PipaConsentValue;
    consentDataInternational: PipaConsentValue;
}

export class PipaConsent implements IPipaConsent {
    constructor(
        public consentDataCollection: PipaConsentValue = "",
        public consentDataThirdparty: PipaConsentValue = "",
        public consentDataInternational: PipaConsentValue = "",
    ) {}
}
